import React                       from 'react';
import { createPortal }            from 'react-dom';
import { ONBOARDING_TARGET_CLASS } from '@/TokamapEditor/stores/onboardingStore';
import currentEditorStore          from '@/TokamapEditor/stores/currentEditorStore';

const CONTEXT_MENU_ITEM = '.context-menu__item';
const DELETE_LABEL = 'Supprimer';

type Box = { left: number; top: number; width: number; height: number };

const shapeBox = (shapeId: string): Box | null => {
	const editor = currentEditorStore.get;
	const shape = editor?.getAllShapes().find(candidate => candidate.id === shapeId);
	const map = editor?.mapAdapter.getMapForTests();

	if (!shape || !map) return null;

	const canvas = map.getCanvas().getBoundingClientRect();
	const points = (shape.coordinates as [number, number][]).map(point => map.project(point));
	const xs = points.map(point => point.x);
	const ys = points.map(point => point.y);

	return {
		left: Math.round(canvas.left + Math.min(...xs)),
		top: Math.round(canvas.top + Math.min(...ys)),
		width: Math.round(Math.max(...xs) - Math.min(...xs)),
		height: Math.round(Math.max(...ys) - Math.min(...ys)),
	};
};

const deleteItem = () => [...document.querySelectorAll(CONTEXT_MENU_ITEM)].find(item => item.textContent?.includes(DELETE_LABEL));

const OnboardingShapeAnchor = ({ shapeId }: { shapeId: string; }) => {
	const [box, setBox] = React.useState<Box | null>(null);

	React.useEffect(() => {
		let frame = 0;
		let tagged: Element | undefined;

		const track = () => {
			const item = deleteItem();

			if (item !== tagged) {
				tagged?.classList.remove(ONBOARDING_TARGET_CLASS);
				item?.classList.add(ONBOARDING_TARGET_CLASS);
				tagged = item;
			}

			const next = item ? null : shapeBox(shapeId);

			setBox(previous => JSON.stringify(previous) === JSON.stringify(next) ? previous : next);
			frame = requestAnimationFrame(track);
		};

		track();

		return () => {
			cancelAnimationFrame(frame);
			tagged?.classList.remove(ONBOARDING_TARGET_CLASS);
		};
	}, [shapeId]);

	if (!box) return null;

	return createPortal(
		<div className={ONBOARDING_TARGET_CLASS} style={{ position: 'fixed', ...box, pointerEvents: 'none' }} />,
		document.body,
	);
};

export default OnboardingShapeAnchor;
